import { render } from "./classificationList.vue?vue&type=template&id=ca6fe7b0&scoped=true"
import script from "./classificationList.vue?vue&type=script&lang=js"
export * from "./classificationList.vue?vue&type=script&lang=js"

import "./classificationList.vue?vue&type=style&index=0&id=ca6fe7b0&scoped=true&lang=css"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6fe7b0"]])

export default __exports__